export const LOADING_DELAY = 50;
export const MAX_ASSET_UPLOAD_RETRIES = 5;
export const UPLOAD_DELAY = 1000;
